
// working code 
import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
// import { FaCoffee } from 'react-icons/fa'; // Starbucks icon alternative
import { FaLaptopCode } from 'react-icons/fa'; // Python Developer icon
import { FaUniversity } from 'react-icons/fa'; // College/University icon
import "./Experience.css"

const Experience = () => {
  return (
    <section className="experience">
      <div className="bg-gray-900 text-white min-h-screen py-10">
        <h2 className="experienceTitle">Experience</h2>
        <VerticalTimeline>
          {/* Algobulls Internship */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#3f3cbb', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #3f3cbb' }}
            date="March 2024 - July 2024"
            iconStyle={{ background: '#3f3cbb', color: '#fff' }}
            icon={<FaLaptopCode />}
          >
            <h3 className="vertical-timeline-element-title text-lg font-bold">Python Developer</h3>
            <h4 className="vertical-timeline-element-subtitle text-md font-semibold">Algobulls Pvt Ltd</h4>
            <p>
              <ul className="list-disc pl-5">
                <li>Developed and optimized algorithmic trading strategies using Python, focusing on model development and performance improvement.</li>
                <li>Collaborated with the team to integrate models into the trading platform, gaining practical insights into financial markets and risk management.</li>
              </ul>
            </p>
          </VerticalTimelineElement>

          {/* Education */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: '#4b5563', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #4b5563' }}
            date="2023 - 2025"
            iconStyle={{ background: '#e63946', color: '#fff' }}
            icon={<FaUniversity />}
          >
            <h3 className="vertical-timeline-element-title text-lg font-bold">M.Sc. IT</h3>
            <h4 className="vertical-timeline-element-subtitle text-md font-semibold">S.I.E.S College, Mumbai</h4>
            <p>Currently pursuing, expected completion in 2025.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: '#4b5563', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #4b5563' }}
            date="2023"
            iconStyle={{ background: '#e63946', color: '#fff' }}
            icon={<FaUniversity />}
          >
            <h3 className="vertical-timeline-element-title text-lg font-bold">B.Sc. IT</h3>
            <h4 className="vertical-timeline-element-subtitle text-md font-semibold">S.I.E.S College, Mumbai</h4>
            <p>Graduated with an 8.13 CGPA.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: '#4b5563', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #4b5563' }}
            date="2020"
            iconStyle={{ background: '#e63946', color: '#fff' }}
            icon={<FaUniversity />}
          >
            <h3 className="vertical-timeline-element-title text-lg font-bold">HSC</h3>
            <h4 className="vertical-timeline-element-subtitle text-md font-semibold">Andhra Education Society's Junior College</h4>
            <p>Graduated with 63%.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: '#4b5563', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #4b5563' }}
            date="2018"
            iconStyle={{ background: '#e63946', color: '#fff' }}
            icon={<FaUniversity />}
          >
            <h3 className="vertical-timeline-element-title text-lg font-bold">SSC</h3>
            <h4 className="vertical-timeline-element-subtitle text-md font-semibold">Andhra Education Society's Junior College</h4>
            <p>Graduated with 59.20%.</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </section>
  );
};

export default Experience;

